import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../../const";
import _ from 'lodash';
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
import { fetchKids } from "../../../Kids-list.ducks";
import { fetchOneKid } from "../../../../Kids.ducks";

// Arrivée actions

export const POST_SANTE_PENDING = "POST_SANTE_PENDING";
export const POST_SANTE_REJECTED = "POST_SANTE_REJECTED";
export const POST_SANTE_FULFILLED = "POST_SANTE_FULFILLED";

export const GET_SANTE_PENDING = "GET_SANTE_PENDING";
export const GET_SANTE_REJECTED = "GET_SANTE_REJECTED";
export const GET_SANTE_FULFILLED = "GET_SANTE_FULFILLED";

export const PUT_SANTE_PENDING = "PUT_SANTE_PENDING";
export const PUT_SANTE_REJECTED = "PUT_SANTE_REJECTED";
export const PUT_SANTE_FULFILLED = "PUT_SANTE_FULFILLED";

export const DELETE_SANTE_PENDING = "DELETE_SANTE_PENDING";
export const DELETE_SANTE_REJECTED = "DELETE_SANTE_REJECTED";
export const DELETE_SANTE_FULFILLED = "DELETE_SANTE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_SANTE_PENDING:
    case GET_SANTE_PENDING:
    case PUT_SANTE_PENDING:
    case DELETE_SANTE_PENDING:

      return true;
    case POST_SANTE_REJECTED:
    case POST_SANTE_FULFILLED:
    case GET_SANTE_REJECTED:
    case GET_SANTE_FULFILLED:
    case PUT_SANTE_REJECTED:
    case PUT_SANTE_FULFILLED:
    case DELETE_SANTE_REJECTED:
    case DELETE_SANTE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_SANTE_PENDING:
    case POST_SANTE_FULFILLED:
    case GET_SANTE_PENDING:
    case GET_SANTE_FULFILLED:
    case PUT_SANTE_PENDING:
    case PUT_SANTE_FULFILLED:
    case DELETE_SANTE_PENDING:
    case DELETE_SANTE_FULFILLED:
      return null;
    case POST_SANTE_REJECTED:
    case GET_SANTE_REJECTED:
    case PUT_SANTE_REJECTED:
    case DELETE_SANTE_REJECTED:

      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_SANTE_FULFILLED:
    case GET_SANTE_FULFILLED:
    case PUT_SANTE_FULFILLED:
    case DELETE_SANTE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    case POST_SANTE_PENDING:
    case GET_SANTE_PENDING:
      return null;
    case PUT_SANTE_REJECTED:
    case DELETE_SANTE_REJECTED:
      return null;
    default:
      return state;
  }
};

// Arrivée reducer
export default combineReducers({ loading, error, data });

export const postSanteSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/incidents`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_SANTE_FULFILLED, payload: res })
      dispatch(fetchOneKid(tok,id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_SANTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const getSanteEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/incidents/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_SANTE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_SANTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
};

export const updateSanteEvent = (tok, idEvent, data,id) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/incidents/${idEvent}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_SANTE_FULFILLED, payload: res })
      dispatch(fetchOneKid(tok,id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_SANTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
};
export const deleteSanteEvent = (tok, idEvent,id) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/incidents/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_SANTE_FULFILLED, payload: res })
      dispatch(fetchOneKid(tok,id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_SANTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
};